import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { Exchange } from '@shared/store/pay-with-points/pay-with-points.reducers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Balance {
  points: number;
  exchange?: Exchange;
}

@Injectable({ providedIn: 'root' })
export class PayWithPointsService {
  constructor(private http: HttpClient) {}

  public getPoints(): Observable<number> {
    return this.http.get<Balance>(ApiEndpoint.MEMBER_LOYALTY).pipe(map((balance) => balance.points));
  }

  public getPointsWithExchange(category: string): Observable<Exchange> {
    return this.http
      .get<Balance>(ApiEndpoint.MEMBER_LOYALTY, { params: { category, max: true } })
      .pipe(map((balance) => balance.exchange));
  }

  public exchangePointsToCurrency(category: string, points: number): Observable<Exchange> {
    return this.http
      .get<Balance>(ApiEndpoint.MEMBER_LOYALTY, { params: { category, points } })
      .pipe(map((balance) => balance.exchange));
  }

  public exchangeCurrencyToPoints(category: string, amount: number): Observable<Exchange> {
    return this.http
      .get<Balance>(ApiEndpoint.MEMBER_LOYALTY, { params: { category, amount } })
      .pipe(map((balance) => balance.exchange));
  }
}
